export enum NotificationType {
	/// The order is pending
	OrderPending,

	/// The product return request
	ProductReturn,

	/// The follow shop
	FollowShop,

	/// The follow user
	FollowUser,

	/// The like article
	LikeArticle,

	/// The like product
	LikeProduct,

	/// The add wishlist product
	AddWishlistProduct,

	/// The add wishlist wardrobe item
	AddWishlistWardrobeItem,

	/// The AddShopComment
	AddShopComment,

	/// The AddUserComment
	AddUserComment,

	/// The FollowingBirthday
	FollowingBirthday,

	/// The order shipped or partially shipped
	OrderShipped,

	/// The WishlistOnsale
	WishlistOnSale,

	/// The WishlistOnStock
	WishlistOnStock,

	/// The ArticleAdd HOME PAGE FEED
	ArticleAdd,

	/// The WardrobeItemAdd HOME PAGE FEED
	WardrobeItemAdd,

	/// The ProductAdd HOME PAGE FEED
	ProductAdd,

	/// The OutfitAdd HOME PAGE FEED
	OutfitAdd,

	/// The order is processing
	OrderProcessing,

	/// Order reminder (24 hours before order reservation time)
	AppointmentReminder,
}
